import React, { useCallback } from "react"
import * as AppConstants from "../../utility/AppConstants"
import "Css/table.css"
//import { TableFieldsMultiAnno } from "@/utility/model"

function BodyTableCPB(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE

    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_NUMERO_POSIZIONI}{" "}
                </th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.numPosizioniCpb
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.numPosizioniCpb
                            : elemNonDisponibile}{" "}
                    </td>
                ) }
                {props.isCampo3 && (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.numPosizioniCpb
                            : elemNonDisponibile}{" "}
                    </td>
                ) }
                {props.isCampo4 && (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.numPosizioniCpb
                            : elemNonDisponibile}{" "}
                    </td>
                ) }
                {props.isCampo5 && (
                    <td>
                        {props.campo5 !== undefined
                            ? props.campo5.numPosizioniCpb
                            : elemNonDisponibile}
                    </td>
                ) }
            </tr>
            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_REDDITO_CPB} {parseInt(props.anno, 10) + 1} (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.redditoCpbA1 !== undefined
                            ? props.campo1.redditoCpbA1
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.redditoCpbA1 !== undefined
                            ? props.campo2.redditoCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo3 && (
                    <td>
                        {" "}
                        {props.campo3?.redditoCpbA1 !== undefined
                            ? props.campo3.redditoCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo4 && (
                    <td>
                        {" "}
                        {props.campo4?.redditoCpbA1 !== undefined
                            ? props.campo4.redditoCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo5 && (
                    <td>
                        {" "}
                        {props.campo5?.redditoCpbA1 !== undefined
                            ? props.campo5.redditoCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
            </tr>
            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_REDDITO_CPB} {parseInt(props.anno, 10) + 2} (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.redditoCpbA2 !== undefined
                            ? props.campo1.redditoCpbA2
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.redditoCpbA2 !== undefined
                            ? props.campo2.redditoCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo3 && (
                    <td>
                        {" "}
                        {props.campo3?.redditoCpbA2 !== undefined
                            ? props.campo3.redditoCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo4 && (
                    <td>
                        {" "}
                        {props.campo4?.redditoCpbA2 !== undefined
                            ? props.campo4.redditoCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo5 && (
                    <td>
                        {" "}
                        {props.campo5?.redditoCpbA2 !== undefined
                            ? props.campo5.redditoCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
            </tr>

            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_VAL_PROD_CPB} {parseInt(props.anno, 10) + 1} (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.valProdCpbA1 !== undefined
                            ? props.campo1.valProdCpbA1
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.valProdCpbA1 !== undefined
                            ? props.campo2.valProdCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo3 && (
                    <td>
                        {" "}
                        {props.campo3?.valProdCpbA1 !== undefined
                            ? props.campo3.valProdCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo4 && (
                    <td>
                        {" "}
                        {props.campo4?.valProdCpbA1 !== undefined
                            ? props.campo4.valProdCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo5 && (
                    <td>
                        {" "}
                        {props.campo5?.valProdCpbA1 !== undefined
                            ? props.campo5.valProdCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
            </tr>

            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_VAL_PROD_CPB} {parseInt(props.anno, 10) + 2} (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.valProdCpbA2 !== undefined
                            ? props.campo1.valProdCpbA2
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.valProdCpbA2 !== undefined
                            ? props.campo2.valProdCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo3 && (
                    <td>
                        {" "}
                        {props.campo3?.valProdCpbA2 !== undefined
                            ? props.campo3.valProdCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo4 && (
                    <td>
                        {" "}
                        {props.campo4?.valProdCpbA2 !== undefined
                            ? props.campo4.valProdCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                {props.isCampo5 && (
                    <td>
                        {" "}
                        {props.campo5?.valProdCpbA2 !== undefined
                            ? props.campo5.valProdCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
            </tr>
        </React.Fragment>
    )
}
export default BodyTableCPB
